export default __webpack_public_path__ + "pdf/Karen_Miga.97e0584.pdf";